import { useEffect } from 'react';
import OAuth2AuthProvider from '~/config/auth/OAuth2AuthProvider';

export function useJiraOAuth(auth: OAuth2AuthProvider) {
  if (window.location.pathname !== '/oauth/jira/callback') {
    return;
  }

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const code = query.get('code');
    const state = query.get('state');

    if (code && state) {
      auth.sendAuthOAuthRequest(code, state);
    } else {
      console.error('Jira OAuth data not found');
    }
  }, [auth]);
}
